export default __webpack_public_path__ + "static/media/error-403.0d22847f.jpg";